import { Switch, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";

import { withStyles } from "tss-react/mui";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";
import { ArrowDownward, ArrowUpward, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import ProductOptiesStyle from "./ProductOptiesStyle";
import { toast } from "react-toastify";
import TranslationWrapper, { getTranslation } from "../TranslationWrapper/TranslationWrapper";

class Overzicht extends React.Component {
  state = {
    showDetails: {},
  };

  handleCustomSwitchMain = (key) => {
    let newOpties;

    if (Array.isArray(this.convertOpties())) {
      newOpties = [...this.convertOpties()];
    } else {
      newOpties = { ...this.convertOpties() };
    }

    newOpties[key]["disabled"] = !newOpties[key]["disabled"];
    this.props.onChange(newOpties);
  };

  handleCustomSwitchSub = (mainkey, subkey) => {
    let newOpties;

    if (Array.isArray(this.convertOpties())) {
      newOpties = [...this.convertOpties()];
    } else {
      newOpties = { ...this.convertOpties() };
    }
    newOpties[mainkey]["optie"][subkey]["actief"] =
      newOpties[mainkey]["optie"][subkey]["actief"] !== undefined
        ? !newOpties[mainkey]["optie"][subkey]["actief"]
        : false;
    this.props.onChange(newOpties);
  };

  handleCustomSwitchSubDef = (mainkey, subkey) => {
    let newOpties;

    if (Array.isArray(this.convertOpties())) {
      newOpties = [...this.convertOpties()];
    } else {
      newOpties = { ...this.convertOpties() };
    }

    const maxSelect = newOpties[mainkey]["maxselect"] ?? Infinity;
    const currentState =
      newOpties[mainkey]["optie"][subkey]["default"] !== undefined
        ? newOpties[mainkey]["optie"][subkey]["default"]
        : false;

    // Count how many options are currently selected (default is true)
    const selectedCount = Object.values(newOpties[mainkey]["optie"]).filter(
      (optie) => optie["default"] === true
    ).length;

    // Prevent selecting more options if maxSelect is reached, allow deselecting
    if (!currentState && selectedCount >= maxSelect) {
      let message = getTranslation("product.opties.maxselect.error", "Maximum select reached");

      if (maxSelect === 1) {
        message = getTranslation("product.opties.maxselect.error.singular", "Only one option can be selected");
      }

      toast.error(message);

      return;
    }

    // Toggle the current option's selected state
    newOpties[mainkey]["optie"][subkey]["default"] = !currentState;

    this.props.onChange(newOpties);
  };

  handleGroupPosition = (key, direction) => {
    let newIndex = key;
    let lNewOpties;
    let newOpties = [];
    if (Array.isArray(this.convertOpties())) {
      lNewOpties = [...this.convertOpties()];
    } else {
      lNewOpties = { ...this.convertOpties() };
    }
    for (let i in lNewOpties) {
      newOpties.push(lNewOpties[i]);
    }
    if (direction == "up") {
      newIndex--;
    } else {
      newIndex++;
    }
    if (newIndex >= newOpties.length) {
      var k = newIndex - newOpties.length + 1;
      while (k--) {
        newOpties.push(undefined);
      }
    }
    newOpties.splice(newIndex, 0, newOpties.splice(key, 1)[0]);
    this.props.onChange(newOpties);
  };

  handleItemPosition = (key, subkey, direction) => {
    let newIndex = subkey;
    let newOpties;
    if (Array.isArray(this.convertOpties())) {
      newOpties = [...this.convertOpties()];
    } else {
      newOpties = { ...this.convertOpties() };
    }
    if (direction == "up") {
      newIndex--;
    } else {
      newIndex++;
    }
    if (newIndex >= newOpties[key]["optie"].length) {
      var k = newIndex - newOpties[key]["optie"].length + 1;
      while (k--) {
        newOpties[key]["optie"].push(undefined);
      }
    }
    newOpties[key]["optie"].splice(newIndex, 0, newOpties[key]["optie"].splice(subkey, 1)[0]);
    this.props.onChange(newOpties);
  };

  handleShowDetails = (key) => {
    let showDetails = { ...this.state.showDetails };
    showDetails[key] = showDetails[key] !== undefined ? !showDetails[key] : true;
    this.setState({ showDetails: showDetails });
  };

  convertOpties = () => {
    let opties = false;

    if (!(this.props.opties === null || this.props.opties === "")) {
      opties = this.props.opties;
    }

    if (opties && typeof opties === "string") {
      try {
        opties = JSON.parse(opties);
      } catch (e) {
        opties = false;
      }
    }

    return opties;
  };

  renderOpties = (opties) => {
    let response = [];

    const keys = Object.keys(opties);

    for (let oCc = 0; oCc < keys.length; oCc++) {
      const item = opties[keys[oCc]];
      const mainkey = keys[oCc];

      let showSubItems = this.state.showDetails[mainkey] !== undefined ? this.state.showDetails[mainkey] : false;

      response.push([
        <TableRow key={item.naam} style={{ background: "rgba(255, 152, 0, 0.25)" }}>
          <TableCell onClick={(e) => this.handleShowDetails(mainkey)}>
            {showSubItems ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            <b>{mainkey}</b>
          </TableCell>
          <TableCell />
          <TableCell>
            <b>{item.naam}</b>
          </TableCell>
          <TableCell>
            <b>{item.prijs}</b>
          </TableCell>
          <TableCell>
            <b>{item.vatPerecntage}</b>
          </TableCell>
          <TableCell />
          <TableCell>
            <Switch
              checked={item.is_active_in_pos !== undefined ? item.is_active_in_pos : true}
              defaultChecked
              disabled
            />
          </TableCell>
          <TableCell>
            <Switch
              checked={!(item.disabled !== undefined ? item.disabled : false)}
              onChange={() => this.handleCustomSwitchMain(mainkey)}
            />
          </TableCell>
          <TableCell>
            {oCc > 0 ? (
              <ArrowUpward
                onClick={() => {
                  this.handleGroupPosition(oCc, "up");
                }}
                style={{ color: "green", width: "18px", position: "relative", cursor: "pointer" }}
              />
            ) : null}
            {oCc < keys.length - 1 ? (
              <ArrowDownward
                onClick={() => {
                  this.handleGroupPosition(oCc, "down");
                }}
                style={{ color: "green", width: "18px", position: "relative", cursor: "pointer" }}
              />
            ) : null}
          </TableCell>
        </TableRow>,
        showSubItems ? this.renderSubOpties(item.optie, oCc) : null,
      ]);
    }

    return response;
  };

  renderSubOpties = (optie, mainkey) => {
    let response = [];
    const keys = Object.keys(optie);
    for (let ooCc = 0; ooCc < keys.length; ooCc++) {
      const item = optie[keys[ooCc]];
      const subkey = keys[ooCc];
      response.push([
        <TableRow key={item.naam}>
          <TableCell>
            {mainkey} - {subkey}
          </TableCell>
          <TableCell>{item.img_url ? <img src={item.img_url} style={{ width: "50px" }} /> : null}</TableCell>
          <TableCell>{item.naam}</TableCell>
          <TableCell>{item.prijs}</TableCell>
          <TableCell>{item.vatPercentage}</TableCell>
          <TableCell>
            <Switch
              checked={item.default != undefined && item.default ? true : false}
              onChange={(e) => this.handleCustomSwitchSubDef(mainkey, subkey)}
            />
          </TableCell>
          <TableCell>
            <Switch
              checked={item.is_active_in_pos !== undefined ? item.is_active_in_pos : true}
              defaultChecked
              disabled
            />
          </TableCell>
          <TableCell>
            <Switch
              checked={item.actief == undefined || item.actief ? true : false}
              onChange={(e) => this.handleCustomSwitchSub(mainkey, subkey)}
            />
          </TableCell>
          <TableCell>
            {ooCc > 0 ? (
              <ArrowUpward
                onClick={() => {
                  this.handleItemPosition(mainkey, ooCc, "up");
                }}
                style={{ color: "green", width: "18px", position: "relative", cursor: "pointer" }}
              />
            ) : null}
            {ooCc < keys.length - 1 ? (
              <ArrowDownward
                onClick={() => {
                  this.handleItemPosition(mainkey, ooCc, "down");
                }}
                style={{ color: "green", width: "18px", position: "relative", cursor: "pointer" }}
              />
            ) : null}
          </TableCell>
        </TableRow>,
      ]);
    }

    return response;
  };

  render() {
    const { classes } = this.props;

    let opties = this.convertOpties();

    return (
      <GridContainer>
        <GridItem lg={12} md={12} xs={12}>
          <Table className={classes.table}>
            <colgroup>
              <col width={"100px"} />
              <col width={"auto"} />
              <col width={"50px"} />
            </colgroup>
            <TableHead className={classes.tableRowHead}>
              <TableRow className={classes.tableRowHead}>
                <TableCell style={{ width: "20px" }}>#</TableCell>
                <TableCell
                  className={classes.tableHeadFontSize + " " + classes.tableHeadCell + " " + classes.tableCell}
                  style={{ width: "40px" }}
                >
                  <TranslationWrapper tDefault={"Image"} tKey={"product.options.table.image"} />
                </TableCell>
                <TableCell
                  className={classes.tableHeadFontSize + " " + classes.tableHeadCell + " " + classes.tableCell}
                >
                  <TranslationWrapper tDefault={"Name"} tKey={"product.options.table.name"} />
                </TableCell>
                <TableCell
                  className={classes.tableHeadFontSize + " " + classes.tableHeadCell + " " + classes.tableCell}
                >
                  <TranslationWrapper tDefault={"Price"} tKey={"product.options.table.price"} />
                </TableCell>
                <TableCell
                  className={classes.tableHeadFontSize + " " + classes.tableHeadCell + " " + classes.tableCell}
                >
                  <TranslationWrapper tDefault={"VAT"} tKey={"product.options.table.vat"} />
                </TableCell>
                <TableCell
                  className={classes.tableHeadFontSize + " " + classes.tableHeadCell + " " + classes.tableCell}
                >
                  <TranslationWrapper tDefault={"Default"} tKey={"product.options.table.default"} />
                </TableCell>
                <TableCell
                  className={classes.tableHeadFontSize + " " + classes.tableHeadCell + " " + classes.tableCell}
                >
                  <TranslationWrapper tDefault={"Active in Pos"} tKey={"product.options.table.active_in_pos"} />
                </TableCell>
                <TableCell
                  className={classes.tableHeadFontSize + " " + classes.tableHeadCell + " " + classes.tableCell}
                >
                  <TranslationWrapper tDefault={"Active"} tKey={"product.options.table.active"} />
                </TableCell>
                <TableCell
                  className={classes.tableHeadFontSize + " " + classes.tableHeadCell + " " + classes.tableCell}
                >
                  <TranslationWrapper tDefault={"Position"} tKey={"product.options.table.position"} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{opties && typeof opties === "object" ? this.renderOpties(opties) : null}</TableBody>
          </Table>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(Overzicht, ProductOptiesStyle);
